import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  modal: {
    textAlign: 'center',
    padding: '4rem 2.4rem',
    maxWidth: '65.6rem',
  },
  icon: {
    marginBottom: '2.2rem',
  },
  modalTitle: {
    font: { size: '2.4rem', lineHeight: '3.2rem', weight: 700 },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    margin: { bottom: '2rem' },
    padding: '0 1rem',
  },
  contentText: {
    font: { size: '1.8rem', lineHeight: '2.4rem', weight: 400 },
    letterSpacing: '0.02rem',
    lineHeight: '2.4rem',
    margin: '0 auto',
    color: colors.neutral[700],
    maxWidth: '60rem',
  },
  modalFooter: {
    display: 'flex',
    padding: '0 13%',
    marginTop: '1rem',
    justifyContent: 'center',
    '& button:not(:first-child)': {
      marginLeft: '1.6rem',
    },
  },
  actionButton: {
    padding: '0rem 2rem',
  },
  form: {
    margin: '3rem auto',
    textAlign: 'start',
  },
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
